import { render } from "./TextInput.vue?vue&type=template&id=9fa29e46"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"
script.render = render

export default script